import {
  Autocomplete,
  Box,
  Chip,
  IconButton,
  TextField,
  Typography,
} from '@mui/material'
import { useState } from 'react'
import { PlusIcon } from '~components/icons'
import { COLORS } from '~theme/colors'
import { Z_INDEX } from '~types/z-index'
import { AddDocumentTagModal } from './add-document-tag-modal'

interface DocumentTagsFieldProps {
  disabled?: boolean
  disablePortal?: boolean
  documentTags: string[]
  existingDocumentTags: string[]
  onChange: (tags: string[]) => void
  showDescription?: boolean
}

export function DocumentTagsField({
  disabled = false,
  disablePortal = false,
  documentTags,
  existingDocumentTags,
  onChange,
  showDescription = true,
}: DocumentTagsFieldProps) {
  const [showAddTagModal, setShowAddTagModal] = useState(false)

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <Box
        sx={{
          display: 'flex',
          width: 344,
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Autocomplete
          disabled={disabled}
          limitTags={1}
          size="small"
          multiple
          disableCloseOnSelect
          disablePortal={disablePortal}
          options={existingDocumentTags}
          value={documentTags}
          onChange={(_, newValue) => onChange(newValue)}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                label={option}
                {...getTagProps({ index })}
                key={option}
                size="small"
              />
            ))
          }
          renderInput={(params) => (
            <TextField {...params} label="Document Tags" />
          )}
          sx={{ width: '100%' }}
          slotProps={{ popper: { style: { zIndex: Z_INDEX.Popup } } }}
        />
        <IconButton
          size="small"
          color="primary"
          sx={{ backgroundColor: COLORS.secondary.blueTint }}
          aria-label="add document tag"
          onClick={() => setShowAddTagModal(true)}
          disabled={disabled}
        >
          <PlusIcon />
        </IconButton>
        <AddDocumentTagModal
          open={showAddTagModal}
          setOpen={setShowAddTagModal}
          onAdd={(name) => {
            if (
              existingDocumentTags.includes(name) ||
              documentTags.includes(name)
            ) {
              return
            }
            onChange([...documentTags, name])
          }}
        />
      </Box>
      {showDescription && (
        <Typography variant="caption" sx={{ maxWidth: 344 }}>
          Document tags are optional sub-categories that you can create and
          assign to the document.
        </Typography>
      )}
    </Box>
  )
}
